import Layout from "@/admin/js/layout/index.vue";

const serviceRoutes = {
    name: 'service',
    path: '/services',
    component: Layout,
    meta: { title: 'Мониторинг сервисов', noCache: false },
    redirect: '/services/list',
    children: [
        {
            path: 'list',
            component: () => import('@/admin/js/views/services/index.vue'),
            name: 'Services',
            meta: { title: 'Сервисы' },
        },
        {
            path: 'statistics/:id',
            component: () => import('@/admin/js/views/services/ServiceStatistics.vue'),
            name: 'ServiceStatistics',
            meta: { title: 'Статистика сервисов' },
            props: true
        },
    ],
};

export default serviceRoutes;
